import { gql } from "@apollo/client";

export const GET_ALL_SALES_EMAILS = gql`
  query GetAllSalesEmails {
    getAllSalesEmails {
      _id
      email
      name
      status
      createdAt
      assignedTo {
        _id
        firstname
        lastname
        email
        department
      }
    }
  }
`;

export const GET_SALES_EMAILS_BY_EMPLOYEE = gql`
  query GetSalesEmailsByEmployee($employeeId: String!) {
    getSalesEmailsByEmployee(employeeId: $employeeId) {
      _id
      email
      name
      status
    }
  }
`;

export const CREATE_SALES_EMAIL = gql`
  mutation CreateSalesEmail($email: String!, $name: String) {
    createSalesEmail(email: $email, name: $name) {
      success
      message
      id
    }
  }
`;

export const UPDATE_SALES_EMAIL = gql`
  mutation UpdateSalesEmail($id: String!, $name: String, $status: Boolean) {
    updateSalesEmail(id: $id, name: $name, status: $status) {
      success
      message
    }
  }
`;

export const DELETE_SALES_EMAIL = gql`
  mutation DeleteSalesEmail($id: String!) {
    deleteSalesEmail(id: $id) {
      success
      message
    }
  }
`;

export const ASSIGN_SALES_EMAIL = gql`
  mutation AssignSalesEmailToEmployee($salesEmailId: String!, $employeeId: String!) {
    assignSalesEmailToEmployee(salesEmailId: $salesEmailId, employeeId: $employeeId) {
      success
      message
    }
  }
`;

export const REVOKE_SALES_EMAIL = gql`
  mutation RevokeSalesEmailFromEmployee($salesEmailId: String!, $employeeId: String!) {
    revokeSalesEmailFromEmployee(salesEmailId: $salesEmailId, employeeId: $employeeId) {
      success
      message
    }
  }
`;

export const UPDATE_PERSONAL_OUTLOOK_ACCESS = gql`
  mutation UpdatePersonalOutlookAccess($employeeId: String!, $enabled: Boolean!) {
    updatePersonalOutlookAccess(employeeId: $employeeId, enabled: $enabled) {
      success
      message
    }
  }
`;
